import { AddByEmail, AddByEmailConfig, AddByEmailResult } from 'components/forms/AddByEmail';
import { useCreatePartnerUser } from 'hooks/useCreatePartnerUser';
import { useCurrentUser } from 'hooks/useCurrentUser';
import React from 'react';

interface Props {
  onClose: () => void;
}

export const AddUserModal = ({ onClose }: Props) => {
  const [createPartnerUser] = useCreatePartnerUser();
  const user = useCurrentUser();

  const config: AddByEmailConfig = {
    title: 'Add Users by Email',
    headerText: 'Add users',
    confirmText: 'Add Users',
    successText: count => `${count} users were added successfully:`,
    failureText: count => `${count} email addresses were invalid:`,
  };

  const handleInvite = async (emails: string[]): Promise<AddByEmailResult[]> => {
    return Promise.all(
      emails.map(async email => {
        try {
          await createPartnerUser({
            partnerId: user.primaryPartner.id,
            payload: { email },
          });
          return { email, success: true };
        } catch (error) {
          console.error(`Error inviting user ${email}:`, error);
          return { email, success: false };
        }
      })
    );
  };

  return (
    <AddByEmail
      config={config}
      onClose={onClose}
      onInvite={handleInvite}
    />
  );
};
